<template>
  <textarea
    ref="textareaRef"
    :value="sanitizedValue"
    :rows="effectiveRows"
    @keydown.enter.prevent
    @input="handleInput"
  ></textarea>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number, null],
    default: '',
  },
  rowsDesktop: {
    type: [String, Number],
    default: 2,
  },
  rowsMobile: {
    type: [String, Number],
    default: 3,
  },
})

const emit = defineEmits(['update:modelValue'])
const isMobile = ref(false)
const textareaRef = ref(null)

function sanitizeSingleLine(value) {
  return String(value || '')
    .replace(/[\r\n]+/g, ' ')
    .replace(/\s{2,}/g, ' ')
}

const sanitizedValue = computed(() => sanitizeSingleLine(props.modelValue))
const effectiveRows = computed(() => (isMobile.value ? props.rowsMobile : props.rowsDesktop))

function updateMobileState() {
  if (typeof window === 'undefined') return
  isMobile.value = window.innerWidth <= 767
}

onMounted(() => {
  updateMobileState()
  window.addEventListener('resize', updateMobileState)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateMobileState)
})

watch(
  () => props.modelValue,
  newValue => {
    const sanitized = sanitizeSingleLine(newValue)
    if (sanitized !== newValue) {
      emit('update:modelValue', sanitized)
    }
  }
)

function handleInput(event) {
  emit('update:modelValue', sanitizeSingleLine(event?.target?.value || ''))
}

function focus() {
  textareaRef.value?.focus()
}

defineExpose({
  focus,
})
</script>
